export const switchActions = {
    changeTab,
}

function changeTab(tab){
    return dispatch => {
        dispatch({ type: tab });
    }
}